import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { MktTaggingTransformationService } from "src/app/core/services";
import { AdaFriendlyNamePipe } from "src/app/common/pipes/ada-friendly-name.pipe";
@Injectable({
  providedIn: 'root'
})
export class PdpTaggingService {
  private isBrowser: boolean;
  taggingObj: any = {
    "app_hierarchy": "public|marketing|<card_product_name>|pdp",
    "event": "",
    "page_type": "", // overlay
    "link_name": "",
    "form_type": "Internally Hosted",
    "cust_error": "",
    "lead_type": "cards|pdp",
    //     "prospect_id": "", // not required for family page
//     "affinity_code": "",
    "pid": "",
    "products": [],
    "client_type_id": "",
    "page_inter": "",
    "test_id": "196_4 l Cards Product Details Page",
  }

  familyTaggingObj: any = {
    ...this.taggingObj,
    app_hierarchy: 'public|marketing|<card_category>|mpp',
    form_type: 'Static Banner',
    lead_type: 'cards|mpp'
  }
  taggingCardNameMap: any = {};


  pdpFamilyCategories = ['strata', 'aadvantage'];

  constructor(
    private _ada: AdaFriendlyNamePipe,
    private _mktTagging: MktTaggingTransformationService,
    @Inject(PLATFORM_ID) private _platformId: string,
  ) {
    this.isBrowser = isPlatformBrowser(this._platformId);
  }

  setTag(taggingObj) {
    if(taggingObj) this.taggingObj = {...taggingObj};
  }

  initTaggingTransformationCc(pageName) {
    if (!this.isBrowser) { return; }
    const test_id = "196_4 l Cards Product Details Page";
    const event = 'product_view';
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, event } });
  }

  applyNowClicked(section) {
    if (!this.isBrowser) { return; }
    const test_id = "196_4 l2 Cards Product Details Page - Apply Now";
    const app_hierarchy = this.taggingObj.app_hierarchy + ':apply now';
    const link_name = this._ada.sanitizePlainText(`Apply Now|${section}`); // TODO: Replace dynamice value
    const event = 'click_to_apply';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, link_name, app_hierarchy, event } });
  }

  anchorLinkClicked(title) {
    if (!this.isBrowser) { return; }
    const test_id = "196_4 l3 Cards Product Details Page - Anchor Link Clicked";    
    const app_hierarchy = this.taggingObj.app_hierarchy + ':anchor link clicked';
    const page_inter = title;
    const event = 'page_interaction';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, app_hierarchy, event } });
  }

  internalLinkClicked(linkName, section) {
    if (!this.isBrowser) { return; }
    const test_id = "196_4 l4 Cards Product Details Page - Internal Link Clicked";
    const app_hierarchy = this.taggingObj.app_hierarchy + ':internal link clicked';
    const link_name = this._ada.sanitizePlainText(`${linkName}|${section}`);
    const event = 'custom_link_click';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, link_name, app_hierarchy, event } });
  }

  externalLinkClicked(linkName, section) {
    if (!this.isBrowser) { return; }
    const test_id = "196_4 l19 Cards Product Details Page - Exit Link Clicked";
    const app_hierarchy = this.taggingObj.app_hierarchy + ':exit link clicked';
    const link_name = this._ada.sanitizePlainText(`${section}|${linkName}`);
    const event = 'exit_links';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, link_name, app_hierarchy, event } });
  }

  navCategory(value: string, key: string) {
    if (!this.isBrowser) { return; }
    const test_id = '196_4 l17 Cards Product Details Page - Find the Right Card for You Icon Clicked';
    const event = 'custom_link_click';
    const link_name = `${key}|${value}`;
    const app_hierarchy = this.taggingObj.app_hierarchy + ':find the right card for you icon clicked';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, event, link_name, app_hierarchy } });
  }

  additionalInfoClicked() {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l5 Cards Product Details Page - Additional Information Modal';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':additional information';
    const page_type = 'overlay';
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_type, app_hierarchy } });
  }

  callToApply() {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l6 Cards Product Details Page - Call to Apply Modal';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':call to apply';
    const page_type = 'overlay';
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_type, app_hierarchy } });
  }

  costcoLinkClicked(linkName) {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l7 Cards Product Details Page - Costco Link Clicked';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':costco link clicked';
    const event = 'page_interaction';
    const page_inter = linkName || 'Join Costco';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

  calcLinkClicked(linkName) {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l8 Cards Product Details Page - Earnings Calculator Interaction';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':earnings calculator interaction';
    const event = 'page_interaction';
    const page_inter = linkName || 'Join Costco'; //<earnings_multiplier_section>|<earnings_multiplier_sub_section>|<interaction_method>
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

  accordianClicked(linkName, show) {
    if (!this.isBrowser) { return; }
    let test_id = show ? '196_4 l9 Cards Product Details Page - Show Accordion Section' : '196_4 l10 Cards Product Details Page - Hide Accordion Section';
    const app_hierarchy = this.taggingObj.app_hierarchy + `:${show ? 'show' : 'hide'} accordion section`;
    const event = 'page_interaction';
    const page_inter = linkName;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

  validationClicked(errorMessage) {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l11 Cards Product Details Page - Inline Error Message';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':inline error message';
    const cust_error = 'Enter 6-digit promo code|A 6-digit code is required. Otherwise, enter 000000.';
    const event = 'page_interaction|custom_error';
    const page_inter = 'Enter 6-digit promo code';
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, cust_error, event, app_hierarchy } });
  }

  benefitClicked(value: string, key: string) {
    if (!this.isBrowser) { return; }
    let test_id = '196_4 l12 Cards Product Details Page - Display Tile Details';
    const app_hierarchy = this.taggingObj.app_hierarchy + `:display tile details`;
    const event = 'page_interaction';
    const page_inter = `${key}|${value}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

  drawarClick(value: string, key: string, show) {
    if (!this.isBrowser) { return; }
    let test_id = show ? '196_4 l13 Cards Product Details Page - Show Topic' : '196_4 l14 Cards Product Details Page - Hide Topic';
    const app_hierarchy = this.taggingObj.app_hierarchy + `:${show ? 'show' : 'hide'} topic`;
    const event = 'page_interaction';
    const page_inter = `${key}|${value}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

  faqClick(value: string, key: string, show) {
    if (!this.isBrowser) { return; }
    let test_id = show ? '196_4 l15 Cards Product Details Page - Show FAQ' : '196_4 l16 Cards Product Details Page - Hide FAQ';
    const app_hierarchy = this.taggingObj.app_hierarchy + `:${show ? 'show' : 'hide'} faq`;
    const event = 'page_interaction';
    const page_inter = `${key}|${value}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_inter, event, app_hierarchy } });
  }

// Family Page - Tagging starts

public initTaggingFamilyPage(pageName): void {
    if (!this.isBrowser) { return; }
    const test_id = "197 c Cards - Card Category MPP";
    const event = 'product_info|product_view';
    let categoryName = this.pdpFamilyCategories.find(pName => (pageName.includes(pName)));
    this.taggingObj.app_hierarchy = this.taggingObj.app_hierarchy.replace("<card_category>", categoryName); // Applicable only to PDP Family Page
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, event } });
  }

  public navCategoryFamily(value: string): void {
    if (!this.isBrowser) { return; }
    const test_id = '197 c5 Cards - Card Category MPP - New Category Selected';
    const event = 'page_interaction';
    const page_inter = value;
    const app_hierarchy = `${this.taggingObj.app_hierarchy}:new category selected`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, event, page_inter, app_hierarchy } });
  }

  public internalLinkClickedFamily(linkName, isApplyNow, pid, priceDetails, section = ''): void {
    if (!this.isBrowser) { return; }
    const test_id = (section.includes('sticky') ? '197 c11 Cards - Card Category MPP - Sticky Nav Link Clicked' : '197 c7 Cards - Card Category MPP - Card Tile Link Clicked');
    const app_hierarchy = this.taggingObj.app_hierarchy + (section.includes('sticky') ? ':sticky nav link clicked' : ':card tile link clicked');
    const event = `page_interaction${isApplyNow ? '|click_to_apply' : ''}`;
    const { products, productName } = this.getproduct(pid, priceDetails) || {};
    const page_inter = `${productName}|${linkName}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, app_hierarchy, event, pid, products, page_inter } });
  }
  
  public additionalInfoClickedFamily(pid: string): void {
    if (!this.isBrowser) { return; }
    let test_id = '197 c10 Cards - Card Category MPP - Additional Information';
    const app_hierarchy = this.taggingObj.app_hierarchy?.replace('mpp', 'view all cards') + ':additional information';
    const page_type = 'overlay';
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, page_type, app_hierarchy, pid, form_type: '', products: [] } });
  }

  public stickyCTAModalOpenFamily(): void {
    if (!this.isBrowser) { return; }
    const test_id = '197 c11 Cards - Card Category MPP - Sticky CTAs Modal';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':sticky ctas modal';
    const page_type = 'overlay';
    return this._mktTagging.triggerPageTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, app_hierarchy, event: '', page_inter: '', page_type } });
  }

  public stickyLinkClickedFamily(pid: string, isApplyNow: boolean, priceDetails: any, linkName: string, closeBtn = false): void {    
    if (!this.isBrowser) { return; }
    const test_id = '197 c12 Cards - Card Category MPP - Sticky CTAs Modal - Link Clicked';
    const app_hierarchy = this.taggingObj.app_hierarchy + ':sticky ctas modal:link clicked';
    const { products, productName } = this.getproduct(pid, priceDetails) || {};
    const page_inter = closeBtn ? `${linkName}|X` : `${productName}|${linkName}`;
    return this._mktTagging.triggerEventTagging('nonicms_content', test_id, { dynamicContent: { ...this.taggingObj, test_id, app_hierarchy, event: '', pid, products, page_inter } });
  }

  private getproduct(pid, priceDetails): any {
    if(!pid) {      
      return { products: [], productName: '' };
    }
    const productName = this.taggingCardNameMap[pid];
    const { hashCode } = priceDetails?.find(item => item.productIdentifier == pid) || {};
    const products = [{
      "category": 'cards:acquisition',
      "product_name": `c:${!!hashCode ? pid : productName}`,
      "acquisition_source_code": hashCode || '',
    }];
    return { products, productName };
  }
// Family Page - Tagging ends
}
